import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { debugLog, errorLog } from "../../../logger";
import { FartherAccountId, InstitutionId, TransferId, } from "../../Types";
import ValidationError from "../../ZodError";
import { accountTypesV2 } from "./Types";
const AcatsTransferData = z.object({
    accountType: z.enum(accountTypesV2),
    institutionId: InstitutionId,
    accountNumber: z.string(),
    accountHolderName: z.string(),
    destinationVirtualAccountId: FartherAccountId,
});
const AcatsTransferBody = z.custom();
export const url = () => environment() === "PROD"
    ? "https://middleware.prod.farther.com/transfer/v1/transfers/acats"
    : "https://middleware.uat.farther.com/transfer/v1/transfers/acats";
const Response = z.object({ transferId: TransferId, message: z.string() });
export default async function createAcatsTransfer(acatsTransferData, config, statement) {
    const { data } = await axios.post(url(), createAcatsTransferBody(acatsTransferData, statement), {
        headers: {
            Client: config.clientId,
            Authorization: `Bearer ${config.jwt}`,
            ...(config.advisorId && { Advisor: config.advisorId }),
            "Content-Type": "multipart/form-data",
        },
    });
    const decoded = Response.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = `${createAcatsTransfer.name} returned unexpected data.`;
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
const createAcatsTransferBody = (acatsTransferData, statement) => {
    const formData = new FormData();
    if (statement) {
        formData.append("statement", statement);
    }
    const transferData = {
        accountType: acatsTransferData.type,
        institutionId: acatsTransferData.institutionId,
        accountNumber: acatsTransferData.accountNumber,
        accountHolderName: acatsTransferData.holderName,
        destinationVirtualAccountId: acatsTransferData.accountId,
    };
    debugLog("ACATS - transferData", JSON.stringify(transferData));
    formData.append("transferData", JSON.stringify(transferData));
    return formData;
};
//# sourceMappingURL=createAcatsTransfer.js.map